export enum MyPageSettingsEnum {
  EnableEvent = 'enableEvent',
}
